import { Card, CardContent, CardHeader, Grid, Typography } from "@mui/material";
import { FormProvider, RHFSelectField, RHFTextField } from "../../common/hook-form";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { apiConstants, get, patchGeneric } from "../../common/constants";
import { LoadingButton } from "@mui/lab";
import { useSnackbar } from "notistack";
import PageTitle from "../../components/PageTitle";
import { MerchantFilterCached } from "../../common/ProshipFormComponents";
import Loader from "../../components/Loader";

function UpdateMerchantName() {
    const [isSubmitting, setIsSubmitting] = useState(false)
    const { enqueueSnackbar } = useSnackbar();
    const methods = useForm({
        defaultValues: {
            merchant: "",
            name: "",
            email: "",
            contact_no: "",
            address: "",
            city: "",
            state: "",
            pincode: '',
            country: '',
            companyName: '',
            qcType: '',
        }
    });
    const { handleSubmit, setValue, reset, watch } = methods;
    const merchant = watch("merchant");

    const onSubmit = (data) => {
        setIsSubmitting(true)
        data.id = merchant;
        data.test_merchant = false;
        patchGeneric(apiConstants.MERCHANT_UPDATE, data).then((res) => {
            if (res.status === 204) {
                enqueueSnackbar('Merchant details successfully updated!', { variant: 'success' })
            }
        }).catch((err) => {
            enqueueSnackbar(err.response.data.message, { variant: 'error' })
        }).finally(() => {
            // refetch()
            setIsSubmitting(false)
            reset()
        })
    }


    useEffect(() => {
        if (merchant)
            setIsSubmitting(true)
            get(`${apiConstants.MERCHANT}/${merchant}`).then((res) => {
                setValue("email", res.data.email || "")
                setValue("name", res.data.name || "")
                setValue("contact_no", res.data.contact_no || "")
                setValue("address", res.data.address || "")
                setValue("city", res.data.city || "")
                setValue("state", res.data.state || "")
                setValue("pincode", res.data.pincode || "")
                setValue("country", res.data.country || "")
                setValue("companyName", res.data.companyName || "")
                setValue("qcType", res.data.qcType || "No")
            }).catch((err) => console.log(err)).finally(() => {
                setIsSubmitting(false)
            })
    }, [merchant, setValue])

    return (
        <>
        {isSubmitting && <Loader />}
            <PageTitle>Merchant Update</PageTitle>
            <Card>
                <CardHeader title='Update Details' />
                <CardContent>
                    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={1} sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Grid item xs={6}>
                                <Typography>Select Merchant: </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <MerchantFilterCached />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography>Merchant Name: </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <RHFTextField name="name" label='Name' />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography>Merchant Email: </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <RHFTextField name="email" label='Email' />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography>Contact Number: </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <RHFTextField name="contact_no" label='Contact Number' />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography>Address: </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <RHFTextField name="address" label='Address' />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography>City: </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <RHFTextField name="city" label='City' />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography>State: </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <RHFTextField name="state" label='State' />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography>Pincode: </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <RHFTextField name="pincode" label='Pincode' />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography>Country: </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <RHFTextField name="country" label='Country' />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography>Company Name: </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <RHFTextField name="companyName" label='Company Name' />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography>QC Type: </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <RHFSelectField name='qcType' label="Qc Type" width="100%" options={[
                                    { label: 'Yes', value: 'doorstep' },
                                    { label: 'No', value: 'No' },
                                ]} />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <LoadingButton
                                    loading={isSubmitting}
                                    variant="contained"
                                    size="medium"
                                    type="submit">
                                    Submit
                                </LoadingButton>
                            </Grid>
                        </Grid>
                    </FormProvider>
                </CardContent>
            </Card>
        </>
    )
}

export default UpdateMerchantName;